/** 平台审计 / 站内动态：操作与资源中文标签 */

const ACTION_LABELS: Record<string, string> = {
  // 租户生命周期
  'tenant.create': '租户开户',
  'tenant.delete': '租户注销',
  'tenant.suspend': '租户暂停',
  'tenant.activate': '租户激活',
  'tenant.trial.convert': '试用转正',
  'tenant.export.started': '开始导出租户数据',
  'tenant.export.completed': '租户数据导出完成',
  'tenant.backup.started': '开始备份租户数据',
  'tenant.backup.completed': '租户数据备份完成',
  'tenant.mes.update': '更新 MES 开通配置',
  'tenant.ai_policy.update': '更新租户 AI 策略',
  // 平台配置
  'platform.ai.settings': '更新平台 AI 设置',
  'platform.billing.settings': '更新计费设置',
  'platform.storage.settings': '更新存储设置',
  'platform.branding.settings': '更新 OEM 品牌设置',
  'platform.branding.logo': '上传 OEM LOGO',
  // SOP / 产品
  'sop.create': '创建 SOP',
  'sop.update': '更新 SOP',
  'sop.publish': '发布 SOP',
  'sop.published': 'SOP 已发布',
  'product.deployed': '产品工序部署',
  // 审批
  'workflow.create': '发起审批',
  'workflow.approve': '审批通过',
  'workflow.reject': '审批驳回',
  // 执行
  'execution.start': '开始执行',
  'execution.started': '执行任务已开始',
  'execution.complete': '执行完成',
  'execution.completed': '执行任务已完成',
  'execution.cancel': '取消执行',
  // 文档
  'document.upload': '上传文档',
  'document.delete': '删除文档',
  // 工位
  'station.create': '创建工位',
  'station.delete': '删除工位',
  // 用户 / IAM
  'user.create': '创建用户',
  'user.update': '更新用户',
  'user.delete': '删除用户',
  'user.password_change': '用户修改密码',
  'user.password_reset': '管理员重置密码',
  'user.face_enroll': '录入人脸',
  'user.data_scope.update': '更新数据权限范围',
  // 生产
  'production.report': '生产报工',
  'workorder.received': '接收工单',
  'adjustment.request': '申请产量调整',
  'adjustment.approve': '批准产量调整',
  'adjustment.reject': '驳回产量调整',
  'barcode.hold.create': '条码锁定',
  'barcode.hold.release': '条码解锁',
  // 班次
  'shift.assignment.create': '创建排班',
  'shift.assignment.update': '更新排班',
  'shift.assignment.delete': '删除排班',
  // 安灯
  'andon.created': '安灯告警创建',
  'andon.escalated': '安灯告警升级',
  'andon.resolved': '安灯告警已解决',
  // 缺陷选项
  'defect.version.submit': '提交缺陷选项版本',
  'defect.version.publish': '发布缺陷选项版本',
  // API Key
  'api_key.create': '创建 Open API 密钥',
  'api_key.revoke': '撤销 Open API 密钥',
  // IoT / MQTT 运维
  'iot.telemetry.received': '收到 IoT 遥测',
  'mqtt_ops_test_connect': 'MQTT 连接探测',
  'mqtt_ops_sync_station_mqtt': '同步工位 MQTT 配置',
  'ops_test_connect': 'MQTT 连接探测',
  'ops_publish': 'MQTT 运维发布',
  // 其它
  'test.e2e': '端到端测试',
};

const RESOURCE_LABELS: Record<string, string> = {
  tenant: '租户',
  platform: '平台',
  sop: 'SOP',
  workflow: '审批',
  execution: '执行',
  document: '文档',
  station: '工位',
  user: '用户',
  event: '事件',
  export: '导出',
  production_report: '生产报工',
  production_adjustment: '产量调整',
  shift_assignment: '排班',
  barcode_hold: '条码锁定',
  api_key: 'API 密钥',
  iot: 'IoT',
  defect_option_version: '缺陷选项',
  mqtt_ops: 'MQTT 运维',
};

const DETAIL_KEY_LABELS: Record<string, string> = {
  event: '事件',
  id: '对象编号',
  model: '模型',
  plan: '套餐',
  host: '主机',
  user: '用户',
  username: '用户名',
  topic: '主题',
  name: '名称',
  title: '标题',
  code: '编码',
  status: '状态',
  backend: '存储后端',
  via: '途径',
  ok: '结果',
  method: '方法',
  bytes: '字节',
  backup: '备份',
  reload: '是否重载',
  tenant_id: '租户',
  user_id: '用户',
  sop_id: 'SOP',
  station_id: '工位',
  station_code: '工位编码',
  wo_no: '工单号',
  sn: '序列号',
  reason: '原因',
  remark: '备注',
  version: '版本',
  count: '数量',
  qty: '数量',
  from: '从',
  to: '到',
  result: '结果',
  error: '错误',
  message: '说明',
  path: '路径',
  file: '文件',
  filename: '文件名',
  size: '大小',
  duration_ms: '耗时(ms)',
  ip: 'IP',
  role: '角色',
  plant_id: '工厂',
  product_code: '产品编码',
  material_code: '物料编码',
};

const STATUS_VALUE_LABELS: Record<string, string> = {
  active: '已激活',
  trial: '试用中',
  suspended: '已暂停',
  deleted_pending: '待删除',
  purged: '已清除',
  draft: '草稿',
  published: '已发布',
  pending: '待处理',
  approved: '已批准',
  rejected: '已驳回',
  completed: '已完成',
  cancelled: '已取消',
  running: '进行中',
  true: '是',
  false: '否',
  ok: '成功',
  fail: '失败',
  failed: '失败',
  success: '成功',
};

function shortId(id?: string | null): string {
  if (!id) return '';
  const s = String(id);
  return s.length > 8 ? s.slice(0, 8) : s;
}

function looksLikeUUID(s: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(s);
}

function formatValue(key: string, v: unknown): string {
  if (v == null) return '';
  if (typeof v === 'boolean') return v ? '是' : '否';
  if (typeof v === 'object') {
    try {
      return JSON.stringify(v);
    } catch {
      return String(v);
    }
  }
  let val = String(v);
  if (key === 'ok' || key === 'reload' || key === 'backup') {
    if (val === 'true' || val === '1') return '成功';
    if (val === 'false' || val === '0') return '失败';
  }
  if (STATUS_VALUE_LABELS[val] != null) return STATUS_VALUE_LABELS[val];
  if (key === 'event' && ACTION_LABELS[val]) return ACTION_LABELS[val];
  if ((key === 'id' || key.endsWith('_id')) && looksLikeUUID(val)) {
    return shortId(val) + '…';
  }
  if (looksLikeUUID(val) && (key.includes('id') || key === 'id')) {
    return shortId(val) + '…';
  }
  return val;
}

function labelForKey(k: string): string {
  if (DETAIL_KEY_LABELS[k]) return DETAIL_KEY_LABELS[k];
  if (RESOURCE_LABELS[k]) return RESOURCE_LABELS[k];
  if (k.endsWith('_id')) {
    const base = k.slice(0, -3);
    return (RESOURCE_LABELS[base] || DETAIL_KEY_LABELS[base] || base) + '编号';
  }
  return k.replace(/_/g, ' ');
}

export type DetailRow = { key: string; label: string; value: string };

/** 把 detail 解析成键值行，供展开区展示 */
export function parseDetailRows(detail?: string | null): DetailRow[] {
  if (!detail || !String(detail).trim()) return [];
  const raw = String(detail).trim();

  try {
    const obj = JSON.parse(raw);
    if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
      return Object.entries(obj as Record<string, unknown>)
        .filter(([, v]) => v != null && v !== '')
        .map(([k, v]) => ({ key: k, label: labelForKey(k), value: formatValue(k, v) }));
    }
  } catch {
    /* plain */
  }

  if (raw.includes('=') && !raw.startsWith('{')) {
    return raw.split(/\s+/).filter(Boolean).map((token) => {
      const eq = token.indexOf('=');
      if (eq <= 0) return { key: token, label: token, value: '' };
      const k = token.slice(0, eq);
      const v = token.slice(eq + 1);
      return { key: k, label: labelForKey(k), value: formatValue(k, v) };
    });
  }

  return [{ key: '_raw', label: '说明', value: raw }];
}

export function humanizeDetail(detail?: string | null): string {
  const rows = parseDetailRows(detail);
  if (!rows.length) return '';
  return rows
    .slice(0, 5)
    .map((r) => (r.value ? `${r.label}：${r.value}` : r.label))
    .join('；');
}

export function actionLabel(action?: string | null): string {
  if (!action) return '未知操作';
  if (ACTION_LABELS[action]) return ACTION_LABELS[action];
  if (action.startsWith('mqtt_ops_agent_')) {
    return 'MQTT 运维·' + action.replace('mqtt_ops_agent_', '');
  }
  if (action.startsWith('ops_agent_')) {
    return 'MQTT 运维·' + action.replace('ops_agent_', '');
  }
  if (action.startsWith('mosquitto_')) {
    return 'Mosquitto·' + action.replace('mosquitto_', '');
  }
  const dot = action.indexOf('.');
  if (dot > 0) {
    const ns = action.slice(0, dot);
    const rest = action.slice(dot + 1).replace(/[._]/g, ' ');
    const nsLabel = RESOURCE_LABELS[ns] || ns;
    return `${nsLabel}·${rest}`;
  }
  return action;
}

export function resourceLabel(rt?: string | null): string {
  if (!rt) return '';
  return RESOURCE_LABELS[rt] || rt;
}

export function tenantLabel(it: {
  tenant_name?: string;
  tenant_code?: string;
  tenant_id?: string;
}): string {
  if (it.tenant_name && it.tenant_code && it.tenant_name !== it.tenant_code) {
    return `${it.tenant_name}（${it.tenant_code}）`;
  }
  if (it.tenant_name) return it.tenant_name;
  if (it.tenant_code) return it.tenant_code;
  if (it.tenant_id) return '租户 ' + shortId(it.tenant_id) + '…';
  return '—';
}

export function userLabel(it: {
  user_display?: string;
  username?: string;
  user_id?: string;
}): string {
  if (it.user_display) return it.user_display;
  if (it.username) return it.username;
  if (it.user_id) {
    if (looksLikeUUID(it.user_id)) return '用户 ' + shortId(it.user_id) + '…';
    return it.user_id;
  }
  return '系统';
}

export type AuditLike = {
  action?: string;
  resource_type?: string;
  resource_id?: string;
  tenant_id?: string;
  tenant_name?: string;
  tenant_code?: string;
  username?: string;
  user_id?: string;
  user_display?: string;
  detail?: string;
  created_at?: string;
};

/** 站内动态摘要：操作人 · 资源 · 租户 · 详情 */
export function formatAuditSummary(it: AuditLike, opts?: { compact?: boolean }): string {
  const compact = !!opts?.compact;
  const parts: string[] = [];
  const actor = userLabel(it);
  if (actor) parts.push(compact ? actor : '操作人：' + actor);

  const res = resourceLabel(it.resource_type);
  if (res && !compact) {
    const rid = shortId(it.resource_id);
    parts.push(rid ? `对象：${res}（${rid}…）` : `对象：${res}`);
  } else if (res && compact) {
    parts.push(res);
  }

  const tLabel = tenantLabel(it);
  if (tLabel && tLabel !== '—') parts.push((compact ? '' : '租户：') + tLabel);

  if (!compact) {
    const detail = humanizeDetail(it.detail);
    if (detail) parts.push(detail);
  }

  const text = parts.join(compact ? ' · ' : ' · ') || '暂无更多说明';
  if (compact && text.length > 48) return text.slice(0, 48) + '…';
  return text;
}

export function formatRelativeTime(iso?: string | null): string {
  if (!iso) return '';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '';
  const diff = Date.now() - t;
  if (diff < 60_000) return '刚刚';
  if (diff < 3600_000) return Math.floor(diff / 60_000) + ' 分钟前';
  if (diff < 86400_000) return Math.floor(diff / 3600_000) + ' 小时前';
  if (diff < 7 * 86400_000) return Math.floor(diff / 86400_000) + ' 天前';
  return new Date(iso).toLocaleString('zh-CN');
}
